import { Component, Input, Output, EventEmitter, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';
import { ComponentBase, Changeable } from "common";

@Component({
	selector: 'agent-settings',
	templateUrl: './agent-settings.component.html',
	styleUrls: ['./agent-settings.component.scss']
})

export class AgentSettingsComponent extends ComponentBase implements OnInit, OnChanges, Changeable {

	@Input() public target: AgentDto;
	public get hasTarget(): boolean {
		return !!this.target;
	}

	public settingsForm: UntypedFormGroup;

	public agentName: UntypedFormControl;
	public agentDesc: UntypedFormControl;
	public configInterval: UntypedFormControl;
	public discStatusInterval: UntypedFormControl;
	public requireLogin: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder) {
		super();

		this.buildForm();
	}

	ngOnInit() {
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.buildForm();
	}

	private buildForm(): void {

		let agentName = "";
		let agentDesc = "";
		let configInterval = 0;
		let discStatusInterval = 0;
		let requireLogin = true;

		if (this.hasTarget) {
			agentName = this.target.Name;
			agentDesc = this.target.Description;
			configInterval = this.secondsToMinutes(this.target.PollInterval);
			discStatusInterval = this.target.DiscoveryStatusInterval;
			requireLogin = this.target.RequireLogin;
		}

		this.agentName = new UntypedFormControl(agentName, Validators.required);
		this.agentDesc = new UntypedFormControl(agentDesc);
		this.configInterval = new UntypedFormControl(configInterval, Validators.compose([Validators.required, this.minValue(1), this.maxValue(1500)]));
		this.discStatusInterval = new UntypedFormControl(discStatusInterval, Validators.compose([Validators.required, this.minValue(15), this.maxValue(3600)]));
		this.requireLogin = new UntypedFormControl(requireLogin);

		this.settingsForm = this.fb.group({
			agentName: this.agentName,
			agentDesc: this.agentDesc,
			configInterval: this.configInterval,
			discStatusInterval: this.discStatusInterval,
			requireLogin: this.requireLogin,
		});
	}

	private secondsToMinutes(seconds: number): number {
		return seconds / 60;
	}

	private minutesToSeconds(minutes: number): number {
		return minutes * 60;
	}

	// Changeable

	public get tempChanges(): boolean {
		return this.settingsForm.dirty;
	}

	public get tempChangesValid(): boolean {
		return this.settingsForm.valid;
	}

	public get invalidTempChanges(): string[] {
		return ["Agent Settings"];
	}

	public applyTempChanges(): void {

		this.target.Name = this.agentName.value;
		this.target.Description = this.agentDesc.value;
		this.target.PollInterval = this.minutesToSeconds(parseInt(this.configInterval.value));
		this.target.DiscoveryStatusInterval = parseInt(this.discStatusInterval.value);
		this.target.RequireLogin = this.requireLogin.value;

		this.target.HasChanges = true;
		this.buildForm();
	}

	public discardTempChanges(): void {
		this.buildForm();
	}
}
